export default __webpack_public_path__ + "static/media/background.dee3d7e0.svg";